<template>
<div>
    <Breadcrumbs main="Admin" submain="Career" title="Applicant" />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body">
                        <b-row>
                            <b-col xl="6">
                                <b-input-group class="datatable-btn">
                                    <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                                    <b-input-group-append>
                                        <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                                    </b-input-group-append>
                                </b-input-group>
                            </b-col>

                            <b-col xl="6">
                                <b-form-group label-cols="2" label="Per page" class="mb-0 datatable-select">
                                    <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <div v-if="!loading && !error">
                            <div class="table-responsive datatable-vue">
                                <b-table show-empty stacked="md" :items="applicant_list" :fields="tablefields" :filter="filter" :current-page="currentPage" :per-page="perPage" @filtered="onFiltered">
                                    <template #cell(index)="data">
                                        {{ (currentPage - 1) * perPage + data.index + 1 }}
                                    </template>

                                    <template #cell(name)="row">
                                        <div style="display: flex; flex-direction: column; align-items: start; justify-items: start; gap: 5px">
                                            <div>{{ row.item.name }}</div>
                                            <span style="display: flex; gap: 4px; font-size: small;"><h7>Position:</h7><h6 style="font-size: small; padding-top: 2px;">{{ row.item.job?.title }}</h6></span>
                                        </div>
                                    </template>

                                    <template #cell(contact)="row">
                                        <div style="display: flex; flex-direction: column; align-items: start; justify-items: start; gap: 5px">
                                            <div>{{ row.item.email }}</div>
                                            <div>{{ row.item.phone }}</div>
                                        </div>
                                    </template>

                                    <template #cell(links)="row">
                                        <div v-if="row.item" style="display: flex; flex-direction: column; align-items: start; justify-items: start; gap: 5px">
                                            <div v-if="row.item.facebook">
                                                <span><a :href="row.item.facebook" target="_blank" rel="noopener noreferrer">Facebook</a></span>
                                            </div>
                                            <div v-if="row.item.linkdin">
                                                <span><a :href="row.item.linkdin" target="_blank" rel="noopener noreferrer">LinkedIn</a></span>
                                            </div>
                                            <div v-if="row.item.portfolio">
                                                <span><a :href="row.item.portfolio" target="_blank" rel="noopener noreferrer">Portfolio</a></span>
                                            </div>
                                        </div>
                                    </template>

                                    <template #cell(cv)="row">
                                        <div v-if="row.item.cv">
                                            <b-badge variant="warning">
                                                <span><a :href="host + row.item.cv" target="_blank" rel="noopener noreferrer">View CV</a></span>
                                            </b-badge>
                                        </div>
                                    </template>

                                    <template #cell(action)="data">
                                        <span style="display: flex; gap: 12px;">
                                            <div>
                                                <feather type="delete" size="22px" style="color: #ff595d; cursor: pointer;" v-b-tooltip.hover v-b-modal.modal-center @click="deleteApplicant(data.item.id)" title="Delete"></feather>
                                            </div>
                                            <div>
                                                <feather type="eye" size="22px" style="color: #568ae3; cursor: pointer;" v-b-tooltip.hover v-b-modal.modal-prevent-view-applicant @click="viewApplicant(data.item)" title="View"></feather>
                                            </div>
                                        </span>
                                    </template>
                                </b-table>
                            </div>
                        </div>

                        <div v-else>
                            <loader />
                        </div>

                        <b-col md="6" class="my-1 p-0">
                            <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" class="my-0"></b-pagination>
                        </b-col>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Container-fluid Ends-->

    <!-- Applicant Delete Modal -->
    <b-modal id="modal-center" centered hide-header @ok="handleDeleteOk">
        <div class="mt-4 mb-4" style="font-size: large;">Are you sure you want to delete this applicant?</div>
    </b-modal>

    <!-- Applicant View -->
     <b-modal id="modal-prevent-view-applicant" ref="modal" title="View Applicant" size="xl" @hidden="resetModal" hide-footer>
        <div>
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <h6>Why do you want to join us?</h6>
                        <div v-html="why_join"></div>
                    </div>
                </div>
            </div>
            <div class="row mt-2">
                <div class="col-sm-12">
                    <div class="form-group">
                        <h6>What sets you apart form others?</h6>
                        <div v-html="why_different"></div>
                    </div>
                </div>
            </div>
        </div>
        <template #modal-footer></template>
    </b-modal>
</div>
</template>

<script>
import { mapState } from 'vuex';
import { myHost } from '../../../_helpers/host';
import loader from '../loader/loader.vue';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';

export default {
    components: {
        loader
    },

    data() {
        return {
            host: myHost.host,
            tablefields: [
                {
                    key: 'index',
                    label: '#'
                },
                {
                    key: 'name',
                    label: 'Name',
                    sortable: true
                },
                {
                    key: 'contact',
                    label: 'Contact',
                    sortable: true
                },
                {
                    key: 'links',
                    label: 'Links',
                    sortable: true
                },
                {
                    key: 'cv',
                    label: 'CV',
                    sortable: true
                },
                {
                    key: 'created_at',
                    label: 'Applied On',
                    sortable: true
                },
                {
                    key: 'action',
                    label: 'Action',
                    sortable: false
                }
            ],
            why_join: null,
            why_different: null,

            delete_value: null,
            filter: null,
            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 15, 20]
        };
    },

    computed: {
        ...mapState({
            applicant_list: state => state.job.applicant,
            loading: state => state.job.applicantLoading,
            error: state => state.job.applicantError
        }),

        sortOptions() {
            // Create an options list from our fields
            return this.tablefields
                .filter(f => f.sortable)
                .map(f => {
                    return {
                        text: f.label,
                        value: f.key
                    };
                });
        }
    },

    mounted() {
        this.$store.dispatch("job/fetchApplicant").then(() => {
            this.items = this.applicant_list
            this.totalRows = this.applicant_list.length;
        });
    },

    methods: {
        viewApplicant(applicant) {
            this.why_join = applicant.why_join
            this.why_different = applicant.why_different
        },

        resetModal() {
            this.why_join = null
            this.why_different = null
        },

        deleteApplicant(id) {
            this.delete_value = id
        },

        handleDeleteOk() {
            this.$store.dispatch("job/deleteApplicant", {
                delete: this.delete_value
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.delete_value = null
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
        }
    }
};
</script>
